import { OnInit, Component, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import * as $ from 'jquery';
import { AplicationsModule } from './aplications/aplications.module';
// import { PRODUCT_TS } from '../MainComponent';
import { HomeModule } from './home/Home';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHttp, JWT_RESPONSE_HEADER } from '../../../tsScripts/providers/http/interceptor';
import { TokenStorage } from '../../../tsScripts/providers/TokenStorage';
import { View401Component } from './view401/view401.component';
import { View404Component } from './view404/view404.component';
import { MessageStorage } from '../../../tsScripts/util/MessageStorage';
import { OptionsHttp } from '../../providers/http/OptionsHttp';
import { ExternalComponent } from './external/external.component';
import { LoginHttp } from '../../../tsScripts/providers/http/LoginHttp';
import { MainHttp } from '../../../tsScripts/providers/http/MainHttp';
import { interval } from 'rxjs';
import { TestComponent } from './test/Test.component';
import { ImageErrorModule } from 'directives/ImageError';

const INVALID_TOKEN_PRODUCT: string = '60040005';
declare let SYSTEM_CONST;
declare let PRODUCT;

@Component({
    selector: 'app',
    templateUrl: '../../../views/components/app/app.html',
    providers: []
})
export class App implements OnInit {
    body = $('body');
    visible = 'menubar-visible';
    fullHeigth = $('body').height() - 72;
    PRODUCT: any;
    // loggedUser: any = {};
    username: any = '';
    profileImage: any = '';
    initialsName: any = '';
    menuOpen: any = true;
    subItemObj: any = {};
    modulesOptions: any = [];
    selectedModule: any = 0;
    currentOption = '';
    errorMessage: string;
    /**
     * determina si el header es visible o no
     */
    headerFlag = true;

    visibleSplash = true;

    SYSTEM_CONST: any;
    /**
     * actual usuario logeado
     */
    currentUserId: string;
    constructor(private router: Router,
        private tokenStorage: TokenStorage,
        private optionsHttp: OptionsHttp,
        private mainHttp: MainHttp,
        private loginHttp: LoginHttp) {
        this.PRODUCT = PRODUCT.LUDYACCOUNT;
    }

    getLoggedUserData() {
        this.mainHttp.getLoggedUserData().then((response) => {
            if (response != null) {
                if (response.firstName != null && response.firstName != '') {
                    if (response.lastName != null && response.lastName != '') {
                        this.username = response.firstName + ' ' + response.lastName;
                    } else {
                        this.username = response.firstName;
                    }
                } else {
                    this.username = response.username;
                }
                if (response.profileImageUrl == null || response.profileImageUrl == '') {
                    if (response.initialsName == null || response.initialsName == '') {
                        this.profileImage = 'images/user2.jpg';
                        $('#usernameProfile').removeClass('top-username-initials-name');
                    } else {
                        this.initialsName = response.initialsName;
                        $('#usernameProfile').addClass('top-username-initials-name');
                        this.profileImage = null;
                    }
                } else {
                    this.profileImage = response.profileImageUrl;
                    $('#usernameProfile').removeClass('top-username-initials-name');
                }
                this.currentUserId = response.agentId;
                // this.loggedUser=response.data;
            }
        });
    }

    showSplash() {
        setTimeout(() => {
            $('#splash').remove();
            this.visibleSplash = false;
        }, 1000);
    }

    validate() {
        if ((this.tokenStorage.getToken() !== undefined && this.tokenStorage.getCookie() !== undefined) ||
        (this.tokenStorage.getToken() !== null && this.tokenStorage.getCookie() !== null)) {
            this.loginHttp.validateToken().subscribe((response) => {
                this.showSplash();
            }, (error) => {
                this.showSplash();
                if (error.errorCode == 0) {
                    this.tokenStorage.resetToken();
                    this.tokenStorage.deleteCookie();
                    window.location.href = '#/login?msg=No es posible establecer conexión con el servidor.&msgType=warning';   
                } else
                if (error.errorCode  == INVALID_TOKEN_PRODUCT) {
                    // this.tokenStorage.resetToken();
                    // window.location.href = `#/lobby?msg=${error.errorMessage}&msgType=info`;
                } else  {
                    this.tokenStorage.resetToken();
                    this.tokenStorage.deleteCookie();
                    window.location.href = '#/login';
                }
            });
        } else {
            window.location.href = '#/login';
        }
    }

    logOut() {
        this.loginHttp.logOut().subscribe((response) => {
            this.tokenStorage.resetToken();
            this.tokenStorage.deleteCookie();
        },
        (error) => {
            MessageStorage.add('error', error.errorMessage);
        });
        this.tokenStorage.resetToken();
        this.tokenStorage.deleteCookie();
        // localStorageFilter.set('dash',null);
        localStorage.reloadToLudyAccount = 'true';
        window.location.href = '#/login';
    }

    getMenuOptions() {
        this.optionsHttp.getDinamicOptions().then((response) => {
            if (response != null) {
                this.modulesOptions = response.resources;
            }
        }, (error) => {
            MessageStorage.add('error', error.errorMessage);
        });
    }

    loadSubItemMenu(menu) {
        if (menu.numChildren > 0 && menu.options == null) {
            menu.loading = true;
            setTimeout(() => {
                const param = {resourceCode: menu.code};
                this.optionsHttp.getDinamicOptions(param).then((response) => {
                    menu.options = response.resources;
                    $('li#' + menu.code).addClass('expanded');
                    menu.loading = false;
                }, (error) => {
                    menu.loading = false;
                    MessageStorage.add('error', error.errorMessage);
                });
            }, 500);
        }
    }

    homeClick() {
        this.selectedModule = 'dash-000';
        this.router.navigateByUrl('/app/home');
    }

    productsClick() {
        this.selectedModule = 'products';
        this.router.navigateByUrl('/app/products');
    }

    itemClicked(menu) {
        this.selectedModule = menu.code;
        this.loadSubItemMenu(menu);
        (menu.properties.actionData) ? this.loadOption(menu) : null;
    }

    loadOption(submenu) {
        this.currentOption = submenu.label;

        switch (submenu.properties.actionData) {

            case 'operation':
                // if (host != 'localhost') {
                //     window.location.href = '../appsl/route.html?t=' + token + '&ope=operacion&u=' + protocol + '://' + host + path + '#';
                // } else {
                //     window.location.href = 'http://localhost:5045/route.html?t=' + token + '&ope=operacion&u=' + protocol + '://' + host + ':' + port + path + '#';
                // }
                break;
            default:
                if (submenu.properties.actionMode == null || submenu.properties.actionMode == 'local') {
                    this.router.navigateByUrl('/app/' + submenu.properties.actionData);

                } else if (submenu.properties.actionMode != null && submenu.properties.actionMode == 'external') {
                    this.router.navigateByUrl('/app/external?url=' + submenu.properties.actionData);

                } else if (submenu.properties.actionMode != null && submenu.properties.actionMode == 'script') {

                    try {
                        eval(submenu.properties.actionData);
                    } catch (e) {
                        MessageStorage.add('error', e);
                    }

                }
        };

        this.closeMenu();


    }

    /**
    * Abre el menu de opciones
    */
    openMenu() {
        if (!this.body.hasClass(this.visible)) {
            this.body.addClass(this.visible);
            $(document).trigger('openMenu');
        } else {
            this.closeMenu();
        }
    }

    /**
    * cierra el menu de opciones
    */
    closeMenu() {
        if (this.body.hasClass(this.visible)) {
            this.body.removeClass(this.visible);
            $(document).trigger('closeMenu');
        }
    }

    showMaintenanceMsg() {
        let msg = localStorage.getItem('maintenanceMsg');
        if (msg !== null && this.tokenStorage.getToken()) MessageStorage.add('warning', msg);
    }

    loadMaintenanceMsg() {
        this.showMaintenanceMsg();
        interval(300000).subscribe(
          () => {
            this.showMaintenanceMsg();
          }
        );
    }

    ngOnInit() {
        $('body').removeAttr('style');
        $('body').removeClass().addClass('home-body menubar-hoverable');
        this.getLoggedUserData();
        this.getMenuOptions();
        this.validate();
        this.loadMaintenanceMsg();
    }
}

@NgModule({
    declarations: [
        App,
        View401Component,
        View404Component,
        ExternalComponent,
        TestComponent
    ],
    imports: [
        FormsModule,
        BrowserModule,
        RouterModule,
        ImageErrorModule,
        HomeModule,
        AplicationsModule,
    ],
    providers: [
        OptionsHttp,
        LoginHttp,
        MainHttp,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttp,
            multi: true
        }
    ],
    entryComponents: [],
    exports: []
})
export class AppModule {
}